/* eslint-disable max-len */
import { ICellRendererParams, ICellRendererComp } from 'ag-grid-community';
import { logoUrl } from '../../../components/bank-logo/bank-logo.component';

export class ManagerCellComponent implements ICellRendererComp {
  public cell: HTMLElement;

  public init(params: ICellRendererParams) {
    this.cell = document.createElement('div');

    if (params.value) {
      this.populateComponent(params.value);
    }
  }

  public getGui() {
    return this.cell;
  }

  public refresh(params: ICellRendererParams): boolean {
    if (params.value) {
      this.populateComponent(params.value);
    } else {
      this.cell.innerHTML = '';
    }
    return true;
  }

  private populateComponent({
    orionId,
    shortName,
    name
  }: {
    orionId: number;
    shortName: string;
    name: string;
  }) {
    const imgUrl = orionId
      ? `<img src="${logoUrl(orionId, 20)}"
          alt="bank logo"
          width="20"
          height="20"
          style="
            float: left;
            margin: 3px 5px 0 -6px;
            height: 20px;
            width: 20px;
          " />`
      : `<img alt="no bank logo on file" 
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8IS0tIENyZWF0ZWQgd2l0aCBNZXRob2QgRHJhdyAtIGh0dHA6Ly9naXRodWIuY29tL2R1b3BpeGVsL01ldGhvZC1EcmF3LyAtLT4KIDxnPgogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4KICA8cmVjdCBmaWxsPSIjZmZmIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iMjIiIHdpZHRoPSIyMiIgeT0iLTEiIHg9Ii0xIi8+CiAgPGcgZGlzcGxheT0ibm9uZSIgb3ZlcmZsb3c9InZpc2libGUiIHk9IjAiIHg9IjAiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIGlkPSJjYW52YXNHcmlkIj4KICAgPHJlY3QgZmlsbD0idXJsKCNncmlkcGF0dGVybikiIHN0cm9rZS13aWR0aD0iMCIgeT0iMCIgeD0iMCIgaGVpZ2h0PSIxMDAlIiB3aWR0aD0iMTAwJSIvPgogIDwvZz4KIDwvZz4KIDxnPgogIDx0aXRsZT5MYXllciAxPC90aXRsZT4KIDwvZz4KPC9zdmc+" width="20"
          height="20"
          style="
            float: left;
            margin: 3px 5px 0 -6px;
            height: 20px;
            width: 20px;
          "/>`;
    const imgText = `<span style="overflow: hidden; text-overflow: ellipsis; display: block;" title="${
      shortName || name
    }">${shortName || name}</span>`;

    this.cell.innerHTML = `${imgUrl}${imgText}`;
  }
}
